import React, {Component} from 'react';
import Card from 'react-bootstrap/Card';
const $ = require('jquery');
const jzip = require('jzip');
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {reject} from 'lodash';
import ClockLoader from 'react-spinners/ClockLoader';
import Select from 'react-select';

window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'เลขใบงาน',
    data: 'planid'
  },
  {
    title: 'วันที่เดินทาง',
    data: 'date_start',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.system === 'travel'
          ? row.date_start
          : row.system === 'recost'
          ? `<input class="btn btn-outline-success btn-xs m-1" type="button" value="โยกงบรายเดือน" disabled id="cc-${row.planid}">`
          : 'อื่นๆ';
      }
      return data;
    }
  },
  {
    title: 'ประเภท',
    data: 'typeName'
  },
  {
    title: 'จุดประสงค์',
    data: 'objectiveShort'
  },
  {
    title: 'แผน | ระยะ (กม.)',
    data: 'distanceValue',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.system === 'travel'
          ? row.distanceValue
          : row.system === 'recost'
          ? `<input class="btn btn-outline-primary btn-xs m-1" type="button" value="${row.budget[0].costCenterName}" disabled id="cc-${row.planid}">`
          : 'อื่นๆ';
      }
      return data;
    }
  },
  {
    title: 'ผล | ระยะ (กม.)',
    data: 'distanceActualValue',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.system === 'travel'
          ? row.distanceActualValue
          : row.system === 'recost'
          ? `<input class="btn btn-outline-secondary btn-xs m-1" type="button" value="${row.budget.reduce(
              (prev, curr) =>
                prev + Number(curr.costRemain.replaceAll(',', '')),
              0
            )}" disabled id="cc-${row.planid}">`
          : 'อื่นๆ';
      }
      return data;
    }
  },
  {
    title: 'รหัสพนักงาน',
    data: 'staffid'
  },
  {
    title: 'ผู้ขอ',
    data: 'staff'
  },
  {
    title: '',
    data: 'planid',
    render: function (data, type, row) {
      // console.log(row);
      if (type === 'display') {
        if (row.enableShortcut) {
          return `<input class="btn btn-primary btn-xs m-1" type="button" value="อนุมัติ" id="a-${data}"><input class="btn btn-danger btn-xs m-1" type="button" value="ไม่อนุมัติ" id="r-${data}">`;
        } else {
          if (row.status === '')
            return `<input class="btn btn-primary btn-xs m-1" type="button" value="on process" disabled id="cp-${data}">`;
          if (row.status === 'approve')
            return `<input class="btn btn-success btn-xs m-1" type="button" value="complete" disabled id="cp-${data}">`;
          if (row.status === 'reject')
            return `<input class="btn btn-danger btn-xs m-1" type="button" value="rejected" disabled id="rj-${data}">`;
          if (row.status === 'cancel')
            return `<input class="btn btn-warning btn-xs m-1" type="button" value="cancelled" disabled id="cc-${data}">`;
        }
      }
      return data;
    }
  },
  {
    title: 'View',
    data: 'planid',
    render: function (data, type, row) {
      if (type === 'display') {
        return `<a class="btn btn-outline-secondary btn-sm" id="${row.planid}_view"><i class="fas fa-search" /></a>`;
      }
      return data;
    }
  }
];

// function reloadTableData(items, page, select = true) {
//   console.log('reload: ' + items.length);
//   console.log('page: ' + page);
//   const table = $(`#${0}`).DataTable();
//   table.clear();
//   table.rows.add(
//     select
//       ? items.filter((e) => e.typeValue === '1')
//       : items.filter((e) => e.typeValue === '2')
//   );
//   table.draw();
//   table.page(page).draw('page');
// }

function reloadTableData(items, page, select = 'A') {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const table = $(`#${0}`).DataTable();
  table.clear();
  table.rows.add(
    select === 'A' ? items : items.filter((e) => e.typeValue === select)
  );
  table.draw();
  table.page(page).draw('page');
}

function reloadTableData1(items, page) {
  console.log('reload1: ' + items.length);
  const table2 = $(`#${1}`).DataTable();
  table2.clear();
  table2.rows.add(items.map((e) => ({...e, enableShortcut: false})));
  table2.draw();
  table2.page(page).draw('page');
}

class TableItem extends Component {
  constructor(props) {
    console.log('HI');
    super(props);
    this.state = {select: true};
  }

  componentDidMount() {
    var table = $(`#${0}`).DataTable({
      data: this.props.items,
      columns,
      searching: true,
      order: [[2, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      destroy: true,
      scrollX: true, // เปิด horizontal scroll
      scrollCollapse: true, // ถ้าตารางเล็กกว่า scroll container

      fixedColumns: {
        leftColumns: 1,
        rightColumns: 2
      },

      columnDefs: [{target: 0, visible: false}],
      fnRowCallback: function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        if (
          aData.date_start !== undefined &&
          new Date(aData.date_start.substring(0, 10)) >
            new Date(Date.now() - 3600 * 1000 * 24)
        ) {
          $('td', nRow).css('background-color', '');
        } else {
          $('td', nRow).css('background-color', '#E0FFFF');
        }
      }
    });

    $(`#${0} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      if ($this.attr('id').split('_')[1] === 'view') {
        this.props.onToggle(data);
      } else {
        this.props.onPrintToggle(data);
      }
    });

    $(`#${0} tbody`).on('click', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      console.log(event.currentTarget.value);
      console.log(data.planid);
      if (event.currentTarget.value === 'อนุมัติ') {
        this.props.onAgree(data.planid, data.system);
      } else {
        this.props.onReject(data.planid, data.system);
      }
    });

    var table2 = $(`#${1}`).DataTable({
      data: this.props.items,
      columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      scrollX: true,
      scrollCollapse: true, // ถ้าตารางเล็กกว่า scroll container

      fixedColumns: {
        leftColumns: 2,
        rightColumns: 2
      }
      // responsive: true,
      // columnDefs: [
      //   {target: 0, responsivePriority: 1},
      //   {target: 1, responsivePriority: 2},
      //   {target: 2, responsivePriority: 1},
      //   {target: 3, responsivePriority: 2},
      //   {target: 4, responsivePriority: 2},
      //   {targets: -3, responsivePriority: 1},
      //   {targets: -2, responsivePriority: 1},
      //   {targets: -1, responsivePriority: 1},
      //   {target: 5, visible: false}
      // ]
    });

    $(`#${1} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table2.row($this.parents('tr')).data();
      if ($this.attr('id').split('_')[1] === 'view') {
        this.props.onToggle(data);
      } else {
        this.props.onPrintToggle(data);
      }
    });

    $(`#${1} tbody`).on('click', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table2.row($this.parents('tr')).data();
      console.log($this.value);
    });

    table.on('page', (event) => {
      var info = table.page.info();
      this.props.onPageChange(info.page);
    });

    table2.on('page', (event) => {
      var info = table2.page.info();
      this.props.onPageHistoryChange(info.page);
    });
  }

  componentWillUnmount() {
    $(`#${0}`).DataTable().destroy(true);
    $(`#${1}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.items1.length !== this.props.items1.length) {
      reloadTableData(
        nextProps.items1.length === 0 ? [] : nextProps.items1,
        nextProps.page,
        nextProps.selectCb.find((e) => e.select === true).value
      );
    } else {
      if (
        nextProps.items1.length >= 1 &&
        nextProps.items1[0].timestamp !== this.props.items1[0].timestamp
      ) {
        reloadTableData(
          nextProps.items1.length === 0 ? [] : nextProps.items1,
          nextProps.page,
          nextProps.selectCb.find((e) => e.select === true).value
        );
      }
    }

    if (nextProps.items2.length !== this.props.items2.length) {
      reloadTableData1(
        nextProps.items2.length === 0 ? [] : nextProps.items2,
        nextProps.pageHistory
      );
    } else {
      if (
        nextProps.items2.length >= 1 &&
        nextProps.items2[0].timestamp !== this.props.items2[0].timestamp
      ) {
        reloadTableData1(
          nextProps.items2.length === 0 ? [] : nextProps.items2,
          nextProps.pageHistory
        );
      }
    }

    return true;
  }

  render() {
    return (
      <div>
        <Card className="card">
          <div className={this.props.loading ? 'overlay dark' : 'd-none'}>
            <ClockLoader color="#c4c4c4" />
          </div>
          <Card.Header>
            <div className="row">
              <div className="col-8">
                รายการรออนุมัติ
                (สลับดูรายการเบิกค่าเดินทาง/รถบริการด้วยปุ่มด้านขวา)
              </div>
              <div className="col-4" style={{textAlign: 'end'}}>
                <Select
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({...base, zIndex: 9999}) // ให้สูงกว่า FixedColumns
                  }}
                  value={this.props.selectCb.find((e) => e.select === true)}
                  options={this.props.selectCb}
                  onChange={(v) => {
                    let _temp = this.props.selectCb.map((e) => ({
                      ...e,
                      select: v.value === e.value
                    }));
                    this.props.setSelectCb(_temp);
                    reloadTableData(
                      this.props.items1,
                      this.props.page,
                      v.value
                    );
                  }}
                />
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={0}
              style={{width: '100%'}}
            />
          </Card.Body>
        </Card>

        <Card className="card-primary">
          <div className={this.props.loading ? 'overlay dark' : 'd-none'}>
            <ClockLoader color="#c4c4c4" />
          </div>
          <Card.Header>รายการประวัติ | ยังไม่ถึงคิว</Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={1}
              style={{width: '100%'}}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
export default TableItem;
